const BASIC_ANIMATION = {
  TO_DOWN: 'to-down',
  FROM_DOWN: 'from-down',
  TO_LEFT: 'to-left',
  FROM_LEFT: 'from-left',
  TO_RIGHT: 'to-right',
  FROM_RIGHT: 'from-right',
  FROM_TOP: 'from-top',
  TO_TOP: 'to-top',
  OPACITY_ENTRANCE: 'opacity-entrance',
  OPACITY_EXIT: 'opacity-exit',
  NONE: ''
} as const;

export const ANIMATION = {
  CLEAR: BASIC_ANIMATION.NONE,
  TO_DOWN: BASIC_ANIMATION.TO_DOWN,
  FROM_DOWN: BASIC_ANIMATION.FROM_DOWN,
  TO_LEFT: BASIC_ANIMATION.TO_LEFT,
  FROM_LEFT: BASIC_ANIMATION.FROM_LEFT,
  TO_RIGHT: BASIC_ANIMATION.TO_RIGHT,
  FROM_RIGHT: BASIC_ANIMATION.FROM_RIGHT,
  FROM_TOP: BASIC_ANIMATION.FROM_TOP,
  TO_TOP: BASIC_ANIMATION.TO_TOP,
  OPACITY_ENTRANCE: BASIC_ANIMATION.OPACITY_ENTRANCE,
  OPACITY_EXIT: BASIC_ANIMATION.OPACITY_EXIT,
  RIGHT: {
    menu: BASIC_ANIMATION.NONE,
    submenu: BASIC_ANIMATION.FROM_LEFT
  },
  LEFT: {
    menu: BASIC_ANIMATION.NONE,
    submenu: BASIC_ANIMATION.TO_LEFT
  },
  NONE: {
    menu: BASIC_ANIMATION.NONE,
    submenu: BASIC_ANIMATION.NONE
  },
  DELAY: 500,
  DELAY_MODAL: 490,
  SHORT_DELAY: 300
} as const;
